import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { coreActions } from '@core/store/core.actions';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html'
})
export class AuthComponent {

  loginForm = this.fb.group({
    username: [undefined, Validators.required],
    password: [undefined, Validators.required]
  });

  returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';

  constructor(
    private fb: FormBuilder,
    private store: Store,
    private route: ActivatedRoute,
  ) { }

  login() {
    if (this.loginForm.valid) {
      this.store.dispatch(coreActions.login({
        username: this.loginForm.value.username,
        password: this.loginForm.value.password,
        returnUrl: this.returnUrl
      }));
    }
  }

}
